import { useMemo, useState } from 'react';

export type UseSearchableListType<T> = {
  list: T[];
  searchValue: string;
  setSearchValue: (text: string) => void;
};

export const useSearchableList = <T extends Record<string, unknown>>(
  list: T[],
  searchBy: (keyof T)[],
): UseSearchableListType<T> => {
  const [searchValue, setSearchValue] = useState<string>('');

  const updatedList = useMemo(() => {
    if (!searchValue) {
      return list;
    }

    return list.filter((item: T) => {
      return searchBy.some((key) => String(item[key]).toLowerCase().includes(searchValue.toLowerCase()));
    });
  }, [list, searchBy, searchValue]);

  return {
    list: updatedList,
    searchValue,
    setSearchValue,
  };
};
